import { render } from "./TabDatiProgetto.vue?vue&type=template&id=8fdaabac"
import script from "./TabDatiProgetto.vue?vue&type=script&lang=js"
export * from "./TabDatiProgetto.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__